import React, {
    useEffect,
    useRef,
    useState,
    useLayoutEffect,
    useCallback,
} from 'react'
import { motion, useTransform, useSpring, useViewportScroll } from 'framer-motion'
import styled from 'styled-components'
import media from 'css-in-js-media'
import ResizeObserver from 'resize-observer-polyfill'
import { useCurrentHeight } from './windowSize'

const HighlightStyle = styled.div`
    overflow: hidden;
    ${media('>=desktop')} {
        height: 88.89vh;
    }
`

const HighlightAnimation = styled(motion.div)`
    ${media('<desktop')} {
        transform: none !important;
        opacity: 1 !important;
        width: 100%;
    }
    ${media('>=desktop')} {
        will-change: transform, opacity;
    }

    * {
        ${media('>=desktop')} {
            height: 100%;
        }
    }
`

const Parallaxanimation = styled(motion.div)`
    ${media('<desktop')} {
        transform: none !important;
        opacity: 1 !important;
        width: 100%;
    }
    ${media('>=desktop')} {
        will-change: transform, opacity;
    }

`

const ParallaxImage = ({ children }) => {
    const { scrollY } = useViewportScroll()
    const windowHeight = useCurrentHeight()
    const positionStart = useRef(null)
    const positionEnd = useRef(null)
    const [getPositionStart, setPositionStart] = useState(0)
    const [getPositionEnd, setPositionEnd] = useState(0)

    useEffect(() => {
        setPositionStart(positionStart.current.offsetTop)
        setPositionEnd(positionEnd.current.offsetTop)
    }, [positionStart, positionEnd])

    const updateHighlights = useCallback((entries) => {
        for (let entry of entries) {
            setPositionStart(entry.target.offsetTop)
        }
    }, [])

    useLayoutEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            updateHighlights(entries)
            setPositionEnd(positionEnd.current.offsetTop)
        })
        positionStart && resizeObserver.observe(positionStart.current)
        return () => resizeObserver.disconnect()
    }, [positionStart, positionEnd])

    const parallaxY = useSpring(
        useTransform(
            scrollY,
            [
                getPositionStart - windowHeight,
                getPositionEnd,
            ],
            [300, -300]
        ),
        { damping: 13, mass: 0.27, stiffness: 75 }
    )


    const stickyY = useSpring(
        useTransform(
            scrollY,
            [
                getPositionStart,
                getPositionStart + 1,
            ],
            [0, 1], {
            clamp: false,
        }
        ),
        { damping: 13, mass: 0.27, stiffness: 75 }
    )

    const highlightOpacity = useSpring(
        useTransform(
            scrollY,
            [
                getPositionStart - windowHeight,
                getPositionStart - windowHeight + windowHeight / 2,
            ],
            [0, 1]
        ),
        { damping: 13, mass: 0.27, stiffness: 75 }
    )

    return (
        <>
            <div ref={positionStart}></div>
            <HighlightStyle>
                <Parallaxanimation
                    style={{
                        y: parallaxY,
                        opacity: highlightOpacity
                    }}
                >
                    <HighlightAnimation
                        style={{
                            y: stickyY,
                        }}
                    >
                        {children}
                    </HighlightAnimation>
                </Parallaxanimation>
            </HighlightStyle>
            <div ref={positionEnd}></div>
        </>
    )
}


export default ParallaxImage
